import React from 'react';

const MinimizeBrandingSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='3'
      viewBox='0 0 16 3'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <line
        x1='1.1'
        y1='1.9'
        x2='14.9'
        y2='1.9'
        stroke={color}
        strokeWidth='2.2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default MinimizeBrandingSVG;
